module.exports = __webpack_public_path__ + "img/usaid.7af5f908.svg";